module.exports = __webpack_public_path__ + "static/homeAffiliations.4bf30dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeAffiliations.png
// module id = 116
// module chunks = 21571696733600 35783957827783 278999228825771